/**
 * A dashboard application (i.e., list of dashboard, global filters...).
 */
export class ReportAppBarClasses {

    /**
     * Style applied to
     */
    static root = "ic3AppBar-root";
    /**
     * Style applied to
     */
    static title = "ic3AppBar-title";

    static titleC = "ic3AppBar-titleC";

    static globalFilter = "ic3AppBar-globalFilter";

    static globalFilterPanel = "ic3AppBar-globalFilterPanel";

}

export declare type ReportAppBarClassKey = keyof ReportAppBarClasses;
